import PropTypes from 'prop-types';
import React, { useState } from 'react';

import CSVImporter from '../../CSVImporter/CSVImporter';

const axios = require('axios').default;
import { toast } from 'react-toastify';
import AsyncSelect from 'react-select/async';
import { toastError } from '../../../shared/toastHelper';

import {
  ADD_EVENTS_MANUAL,
  ADD_EVENTS_CSV
} from '../constants/editTourConstants';

const AddEvents = ({
  csrfToken,
  team,
  currentUser,
  setTourDate,
  tour
}) => {
  const [addEventsMethod, setAddEventsMethod] = useState(ADD_EVENTS_MANUAL);

  return (
    <div>
      <div style={{
              marginTop: '16px',
              marginBottom: '20px',
              borderBottom: "1px solid #E9EAEB",
              paddingBottom: '24px'
            }}>
        <p className="mb-0"
            style={{fontSize: '18px', fontWeight: '600'}}>
          Add Events
        </p>
      </div>
      <div className="row">
        <div className="col-12">
          <form onSubmit={
                  async (e) => {
                    e.preventDefault();

                    if(addEventsMethod === ADD_EVENTS_MANUAL) {
                      try {
                        const response = await axios.get(
                          `/teams/${team.id}/tours/${tour.id}/tour_dates/new`,
                          {
                            headers: {
                              'X-CSRF-Token': csrfToken,
                              'Content-Type': 'application/json'
                            }
                          }
                        );
                        setTourDate(response.data);
                      } catch (error) {
                        toastError('Failed to create new tour date. Please try again.');
                      }
                    }
                  }
                }>
            <div className="card"
                  style={{
                    marginBottom: '10px',
                    border: (addEventsMethod === ADD_EVENTS_MANUAL ? "2px solid #2A9CE4" : "1px solid #E9EAEB")
                  }}>
              <div className="card-body" style={{padding: '16px'}}>
                <div className="custom-control custom-radio custom-control-inline">
                  <input type="radio"
                          id="add-events-manual"
                          name="add-events-method"
                          checked={addEventsMethod === ADD_EVENTS_MANUAL}
                          onChange={() => setAddEventsMethod(ADD_EVENTS_MANUAL)}
                          className="custom-control-input" />
                  <label className="custom-control-label"
                          style={{fontSize: '16px'}}
                          htmlFor="add-events-manual">
                    Manual Entry<br />
                    Manually enter details for each event
                  </label>
                </div>
              </div>
            </div>
            <div className="card"
                  style={{
                    marginBottom: '10px',
                    border: (addEventsMethod === ADD_EVENTS_CSV ? "2px solid #2A9CE4" : "1px solid #E9EAEB")
                  }}>
              <div className="card-body" style={{padding: '16px'}}>
                <div className="custom-control custom-radio custom-control-inline">
                  <input type="radio"
                          id="add-events-csv"
                          name="add-events-method"
                          checked={addEventsMethod === ADD_EVENTS_CSV}
                          onChange={() => setAddEventsMethod(ADD_EVENTS_CSV)}
                          className="custom-control-input" />
                  <label className="custom-control-label"
                          style={{fontSize: '16px'}}
                          htmlFor="add-events-csv">
                    CSV Upload<br />
                    Upload a CSV with all event data
                  </label>
                </div>
              </div>
            </div>
            <div className="form-row"
                  style={{
                    margin: '55px 0px 20px 0px'
                  }}>
              <div className="col-12 text-right">
                {addEventsMethod === ADD_EVENTS_CSV ? (
                  <CSVImporter
                    csrfToken={csrfToken}
                    team={team}
                    importerKey={"04493a0b-e5f8-41ea-a4dd-a18f8c203e3b"}
                    type={"CSVImportRows::TourDate"}
                    additionalParams={{ tour_id: tour.id }}
                    onClose={
                      () => {
                        toast.success("CSV uploaded successfully. Please check back in a few minutes to see the results.", {
                          position: toast.POSITION.TOP_CENTER,
                          draggable: false,
                          closeOnClick: false,
                          autoClose: 5000,
                          hideProgressBar: true
                        });
                      }
                    }
                    renderAnchor={(openModal) => (
                      <a href="#"
                         style={{fontSize: '14px'}}
                         onClick={openModal}
                         className="btn btn-primary">
                        Continue
                      </a>
                    )}
                  />
                ) : (
                  <button type="submit"
                          style={{fontSize: '14px'}}
                          className="btn btn-primary">
                    Continue
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
};

AddEvents.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  setTourDate: PropTypes.func.isRequired,
  tour: PropTypes.object.isRequired
};

export default AddEvents;
